export default __webpack_public_path__ + "static/media/g2021-2.52ba80ca.jpeg";